import { loadStripe } from '@stripe/stripe-js'

import { getStripePublicKey } from 'utils/functions/env'

export const stripePromise = loadStripe(getStripePublicKey())
